import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './joinNow.module.css';
import { SUBSCRIPTION_PRICES } from '../../utils/prices';

export default function JoinNow() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'KNOW - Join Now';
  }, []);

  const handleLicenseNav = (event) => {
    event.preventDefault();
    navigate('/license', { replace: true });
  };

  return (
    <div className={styles.joinContainer} role="main" aria-label="join now">
      <section>
        <p className="h5">Join Now</p>
        <p>
          <span style={{ fontWeight: 'bold' }}>Individual Annual Rates</span>
          <br />
          <br />
          <ul>
            <li>
              1-year access to KNOW: ${SUBSCRIPTION_PRICES.standard_dollars}
              <br />
              <button onClick={handleLicenseNav} style={buttonStyle}>
                Subscribe
              </button>
            </li>
            {/* <li>If you would like to receive additional member benefits, you can join the Oncology Association of Naturopathic Physicians as an Allied Care Provider for ${SUBSCRIPTION_PRICES.allied_dollars}, which includes yearly access to KNOW, discounts to the annual conference, and free webinars. <a href='https://oncanp.org/product/allied-membership/' rel='noopener noreferrer' target='_blank'>Click here to join</a></li> */}
          </ul>
        </p>
        <br />
        <hr style={{ color: 'gray', width: '70%' }} />
        <p>
          For group licensing options, including integration solutions, please email{' '}
          <a href="mailto:info@knowoncology.org">info@knowoncology.org</a>
        </p>
      </section>
    </div>
  );
}

const buttonStyle = {
  backgroundColor: '#8B62B7',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  padding: '8px 16px',
  cursor: 'pointer',
};
